import { GoogleItemType, PromaItemType, RiskItemType } from './itemDefinitions';

const getItemProps = ({ currentView, items, filteredItems }) => {
  const showTabs = currentView.tabs;
  const showListTitles = showTabs ? false : !(currentView.showItems.length === 1);
  const assessmentProps = {
    itemType: RiskItemType.Assessment,
    iconName: 'calendar-alt',
    title: 'Calendars',
    itemName: 'Calendar',
    apiItems: undefined,
    filteredItems: filteredItems.filter((item) => item.itemType === RiskItemType.Assessment),
    showTitle: showListTitles,
    rebucketAction: undefined,
    updateIdParentAction: undefined,
    defaultItem: undefined,
    titleField: undefined,
    disableAdd: true
  };
  const calendarProps = {
    itemType: GoogleItemType.Calendar,
    iconName: 'calendar-alt',
    title: 'Calendars',
    itemName: 'Calendar',
    apiItems: undefined,
    filteredItems: items.filter((item) => item.itemType === GoogleItemType.Calendar),
    showTitle: showListTitles,
    rebucketAction: undefined,
    updateIdParentAction: undefined,
    defaultItem: undefined,
    titleField: undefined,
    disableAdd: true
  };
  const eventProps = {
    itemType: GoogleItemType.Event,
    iconName: 'comment',
    title: 'Events',
    itemName: 'Event',
    apiItems: undefined,
    filteredItems: filteredItems.filter((item) => item.itemType === GoogleItemType.Event),
    showTitle: showListTitles,
    rebucketAction: undefined,
    updateIdParentAction: undefined,
    defaultItem: undefined,
    titleField: 'summary',
    disableAdd: true
  };
  const orgProps = {
    itemType: GoogleItemType.Org,
    iconName: 'comment',
    title: 'Organizations',
    itemName: 'Organization',
    apiItems: undefined,
    filteredItems: filteredItems.filter((item) => item.itemType === GoogleItemType.Org),
    showTitle: showListTitles,
    rebucketAction: undefined,
    updateIdParentAction: undefined,
    titleField: undefined,
    defaultItem: undefined,
    disableAdd: true
  };
  const personProps = {
    itemType: GoogleItemType.Person,
    iconName: 'comment',
    title: 'Persons',
    itemName: 'Person',
    apiItems: undefined,
    filteredItems: filteredItems.filter((item) => item.itemType === GoogleItemType.Person),
    showTitle: showListTitles,
    rebucketAction: undefined,
    updateIdParentAction: undefined,
    titleField: undefined,
    defaultItem: undefined,
    disableAdd: true
  };
  const simResultProps = {
    itemType: RiskItemType.SimResultSheet,
    iconName: 'comment',
    title: 'Simulation results',
    itemName: 'SimResult',
    apiItems: undefined,
    filteredItems: filteredItems.filter((item) => item.itemType === RiskItemType.SimResultSheet),
    showTitle: showListTitles,
    rebucketAction: undefined,
    updateIdParentAction: undefined,
    titleField: undefined,
    defaultItem: undefined,
    disableAdd: true
  };
  const RBSProps = {
    itemType: RiskItemType.RBSRisk,
    iconName: 'comment',
    title: 'Risks',
    itemName: 'Risk',
    apiItems: undefined,
    filteredItems: filteredItems.filter((item) => item.itemType === RiskItemType.RBSRisk),
    showTitle: showListTitles,
    rebucketAction: undefined,
    updateIdParentAction: undefined,
    titleField: undefined,
    defaultItem: undefined,
    disableAdd: true
  };
  const controlProps = {
    itemType: RiskItemType.Control,
    iconName: 'comment',
    title: 'Controls',
    itemName: 'Control',
    apiItems: undefined,
    filteredItems: filteredItems.filter((item) => item.itemType === RiskItemType.Control),
    showTitle: showListTitles,
    rebucketAction: undefined,
    updateIdParentAction: undefined,
    titleField: undefined,
    defaultItem: undefined,
    disableAdd: true
  };
  const taskProps = {
    itemType: PromaItemType.Task,
    iconName: 'comment',
    title: 'Risks',
    itemName: 'Risk',
    apiItems: undefined,
    filteredItems: filteredItems.filter((item) => item.itemType === PromaItemType.Task),
    showTitle: showListTitles,
    rebucketAction: undefined,
    updateIdParentAction: undefined,
    titleField: undefined,
    defaultItem: undefined,
    disableAdd: true
  };
  const achievementProps = {
    itemType: PromaItemType.Achievement,
    iconName: 'comment',
    title: 'Risks',
    itemName: 'Risk',
    apiItems: undefined,
    filteredItems: filteredItems.filter((item) => item.itemType === PromaItemType.Achievement),
    showTitle: showListTitles,
    rebucketAction: undefined,
    updateIdParentAction: undefined,
    titleField: undefined,
    defaultItem: undefined,
    disableAdd: true
  };
  const milestoneProps = {
    itemType: PromaItemType.Milestone,
    iconName: 'comment',
    title: 'Risks',
    itemName: 'Risk',
    apiItems: undefined,
    filteredItems: filteredItems.filter((item) => item.itemType === PromaItemType.Milestone),
    showTitle: showListTitles,
    rebucketAction: undefined,
    updateIdParentAction: undefined,
    titleField: undefined,
    defaultItem: undefined,
    disableAdd: true
  };
  const goalProps = {
    itemType: PromaItemType.FinalGoal,
    iconName: 'comment',
    title: 'Risks',
    itemName: 'Risk',
    apiItems: undefined,
    filteredItems: filteredItems.filter((item) => item.itemType === PromaItemType.FinalGoal),
    showTitle: showListTitles,
    rebucketAction: undefined,
    updateIdParentAction: undefined,
    titleField: undefined,
    defaultItem: undefined,
    disableAdd: true
  };
  const locationProps = {
    itemType: PromaItemType.Location,
    iconName: 'comment',
    title: 'Risks',
    itemName: 'Risk',
    apiItems: undefined,
    filteredItems: filteredItems.filter((item) => item.itemType === PromaItemType.Location),
    showTitle: showListTitles,
    rebucketAction: undefined,
    updateIdParentAction: undefined,
    titleField: undefined,
    defaultItem: undefined,
    disableAdd: true
  };
  const photoProps = {
    itemType: GoogleItemType.Photo,
    iconName: 'comment',
    title: 'Photos',
    itemName: 'Photo',
    apiItems: undefined,
    filteredItems: filteredItems.filter((item) => item.itemType === GoogleItemType.Photo),
    showTitle: showListTitles,
    rebucketAction: undefined,
    updateIdParentAction: undefined,
    titleField: undefined,
    defaultItem: undefined,
    disableAdd: true
  };
  const hotSpotProps = {
    itemType: GoogleItemType.HotSpot,
    iconName: 'comment',
    title: 'Hotspots',
    itemName: 'Hotspot',
    apiItems: undefined,
    filteredItems: filteredItems.filter((item) => item.itemType === GoogleItemType.HotSpot),
    showTitle: showListTitles,
    rebucketAction: undefined,
    updateIdParentAction: undefined,
    titleField: undefined,
    defaultItem: undefined,
    disableAdd: true
  };
  const itemProps = {
    [RiskItemType.Assessment]: assessmentProps,
    [RiskItemType.SimResultSheet]: simResultProps,
    [RiskItemType.RBSRisk]: RBSProps,
    [RiskItemType.Control]: controlProps,
    [GoogleItemType.Calendar]: calendarProps,
    [GoogleItemType.Event]: eventProps,
    [GoogleItemType.Org]: orgProps,
    [GoogleItemType.Person]: personProps,
    [GoogleItemType.Photo]: photoProps,
    [PromaItemType.Task]: taskProps,
    [PromaItemType.Achievement]: achievementProps,
    [PromaItemType.Milestone]: milestoneProps,
    [PromaItemType.FinalGoal]: goalProps,
    [PromaItemType.Location]: locationProps,
    [GoogleItemType.HotSpot]: hotSpotProps
  };

  return itemProps;
};

export default getItemProps;
